import type { IncomingHttpHeaders } from 'http';

const IPV4 = /^(\d{1,3}\.){3}\d{1,3}$/;
const IPV6 = /^[0-9a-fA-F:.]+$/;

function isValidIp(value: string): boolean {
  if (IPV4.test(value)) {
    return value.split('.').every((octet) => Number(octet) <= 255);
  }
  return value.includes(':') && IPV6.test(value);
}

export function clientIpFromHeaders(req: { headers: IncomingHttpHeaders }): string | undefined {
  const raw = req.headers['x-forwarded-for'];
  const header = Array.isArray(raw) ? raw[0] : raw;
  if (!header) return undefined;

  return header
    .split(',')
    .map((entry) => entry.trim())
    .find((entry) => entry !== '' && isValidIp(entry));
}
